import { Router, RouteComponentProps } from "@reach/router"
import { ReferralsDetails } from "./ReferralsDetails"
import { Referrals } from "./Referrals"
import { ReferralsTelemetry } from "./ReferralsTelemetry"
import { ReferralsPricing } from "./ReferralsPricing"
import { ReferralsCustomerBehaviourNotes } from "./ReferralsCustomerBehaviourNotes"
import { ReferralsEndorsements } from "./ReferralsEndorsements"

export const ReferralsRouter: React.FC<RouteComponentProps> = () => (
  <Router>
    <Referrals default />
    <ReferralsDetails path="/:id/details" />
    <ReferralsTelemetry path="/:id/telemetry" />
    <ReferralsPricing path="/:id/pricing" />
    <ReferralsCustomerBehaviourNotes path="/:id/customerBehaviourNotes" />
    <ReferralsEndorsements path="/:id/endorsements" />
  </Router>
)
